<button
  nz-button
  nzType="default"
  class="action-button"
  [ngStyle]="{ height: height, width: width }"
  (click)="onActionClick()"
>
  <va-icon
    [isFontAwesome]="true"
    [name]="actionIcon"
    [ngStyle]="{ display: contentBlock === true ? 'block' : 'inline' }"
    class="action-icon"
  ></va-icon>
  <span class="action-text">{{ actionText }}</span>
</button>
